var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loadFlag)?_c('div',{staticClass:"load"},[_c('van-loading',{attrs:{"type":"spinner"}}),_c('div',{staticStyle:{"padding-top":"10px"}},[_vm._v("加载中...")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }